export default "__VITE_ASSET__ullOwpbv__"